import { createSelector } from 'reselect';

const makeGetVisibleTasks = () => {
  return createSelector(
    state => state.tasks.list,
    state => state.tasks.entities,
    state => state.tasks.filter,
    state => state.students.filter,
    (list, entities, filter, student) => {
      const tasks = list.map(taskId => ({ ...entities[taskId] }));
      if (student) {
        const regexp = new RegExp(student, 'i');
        tasks.forEach(task => {
          task.taskResults = task.taskResults.filter(
            result => result.user.name.search(regexp) > -1
          );
        });
      }
      if (filter.corrected) {
        return tasks;
      } else {
        return tasks
          .filter(task => task.type === 4 || task.type === 7)
          .map(task => {
            const taskResultLength = task.taskResults.length;
            return {
              ...task,
              taskResults: (task.taskResults || []).filter(
                result =>
                  !result.feedback ||
                  !result.feedback.created ||
                  !result.feedbackFiles ||
                  result.feedbackFiles.length < 1
              )
            };
          })
          .filter(task => task.taskResults.length > 0);
      }
    }
  );
};

export const getVisibleTasks = makeGetVisibleTasks();

const makeGetVisibleCourses = () => {
  return createSelector(
    state => state.courses.list,
    state => state.courses.entities,
    state => state.courses.filter,
    (list, entities, filter) => {
      let courses = list.map(id => entities[id]);
      if (filter) {
        const regexp = new RegExp(filter, 'i');
        courses = courses.filter(item => {
          return item.name.search(regexp) > -1;
        });
      }
      courses.sort((a, b) => {
        if (a.uncorrectedCount > b.uncorrectedCount) {
          return -1;
        }
        if (a.uncorrectedCount < b.uncorrectedCount) {
          return 1;
        }
        return 0;
      });
      return courses;
    }
  );
};

export const getVisibleCourses = makeGetVisibleCourses();

const makeGetVisibleStudents = () => {
  return createSelector(
    state => state.students.list,
    state => state.students.entities,
    state => state.students.filter,
    (list, entities, filter) => {
      let students = list.map(id => entities[id]);
      if (filter) {
        const regexp = new RegExp(filter, 'i');
        students = students.filter(item => {
          return item.name.search(regexp) > -1;
        });
      }
      students.sort((a, b) => {
        if (a.uncorrectedCount > b.uncorrectedCount) {
          return -1;
        }
        if (a.uncorrectedCount < b.uncorrectedCount) {
          return 1;
        }
        return 0;
      });
      return students;
    }
  );
};

export const getVisibleStudents = makeGetVisibleStudents();

const makeGetVisibleGroups = () => {
  return createSelector(
    state => state.groups.list,
    state => state.groups.entities,
    state => state.groups.filter,
    (list, entities, filter) => {
      const groups = list.map(id => entities[id]);
      if (filter) {
        const regexp = new RegExp(filter, 'i');
        return groups.filter(item => {
          return item.name.search(regexp) > -1;
        });
      }
      return groups;
    }
  );
};

export const getVisibleGroups = makeGetVisibleGroups();



// WEBPACK FOOTER //
// ./src/js/selectors/tasks.js